import { useState, useEffect } from 'react';
import { evaluateAdCustomizers } from '@bingads-webui-campaign/ad-customizers-next';

const adType = 'ResponsiveAd';

export const useEvaluatedAssests = ({ headline, longHeadline, description }) => {
  const [evaluatedHeadLine, setEvaluatedHeadLine] = useState(headline);
  const [evaluatedLongHeadLine, setEvaluatedLongHeadLine] = useState(longHeadline);
  const [evaluatedDescription, setEvaluatedDescription] = useState(description);

  useEffect(() => {
    evaluateAdCustomizers({
      text: headline,
      adType,
      field: 'Headlines',
    }).then((evaluatedText) => {
      setEvaluatedHeadLine(evaluatedText);
    });
  }, [headline]);

  useEffect(() => {
    evaluateAdCustomizers({
      text: description,
      adType,
      field: 'Descriptions',
    }).then((evaluatedText) => {
      setEvaluatedDescription(evaluatedText);
    });
  }, [description]);

  useEffect(() => {
    evaluateAdCustomizers({
      text: longHeadline,
      adType,
      field: 'LongHeadlines',
    }).then((evaluatedText) => {
      setEvaluatedLongHeadLine(evaluatedText);
    });
  }, [longHeadline]);

  return {
    evaluatedHeadLine,
    evaluatedLongHeadLine,
    evaluatedDescription,
  };
};
